import React, { useState, useRef, useContext } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MuiAlert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import Switch from "@mui/material/Switch";
import Alert from "@mui/material/Alert";
import SimpleBackdrop from "../../Components/Backdrop";
import { useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "../../Layout";
import { useEffect } from "react";
import { changeIDFormula } from "./FormUpdateQuestion";
import { APIServices } from "./../../helpers/APIServices";
import { useSnackbarStore } from "../../helpers/state";

const labelCheckbox = { inputProps: { "aria-label": "Checkbox demo" } };

const label = { inputProps: { "aria-label": "Switch demo" } };

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export const searchPartID = (url) => {
  if (typeof url !== "string") {
    throw Error("url should be type string").stack;
  }
  const arr = url.split("/");
  return arr[4];
};

function TemplateEdit({
  subCat,
  setOpen,
  open,
  setSuccess,
  templateData,
  onUpdate,
}) {
  const location = useLocation();
  const partId = searchPartID(location.pathname);
  const [revise, setRevise] = useState(false);
  const [question, setQuestion] = useState();
  const [specMin, setSpecMin] = useState();
  const [specMax, setSpecMax] = useState();
  const [inspectionTool, setInspectionTool] = useState();
  const [remark, setRemark] = useState();
  const [UCL_Xbar, setUCL_Xbar] = useState();
  const [CL_Xbar, setCL_Xbar] = useState();
  const [LCL_Xbar, setLCL_Xbar] = useState();
  const [UCL_Rchart, setUCL_Rchart] = useState();
  const [CL_Rchart, setCL_Rchart] = useState();
  const [LCL_Rchart, setLCL_Rchart] = useState();
  const [revisionRecord, setRevisionRecord] = useState("");
  const [part, setPart] = useState("");
  const user = useContext(UserContext);
  const [template, setTemplate] = useState("");
  const [templates, setTemplates] = useState("");
  const [openEditTemplate, setOpenEditTemplate] = useState(false);
  const navigate = useNavigate();

  const [imageQuestion, setImageQuestion] = useState("");
  const [alert, setAlert] = React.useState({
    open: false,
    type: "info",
    massage: "",
  });
  const [isSC, setIsSC] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMinMax, setErrorMinMax] = useState(false);
  const [refetchUpdated, setRefetchUpdated] = useState(false);
  const switchRef = useRef();
  const questionRef = useRef();
  const specMinRef = useRef();
  const specMaxRef = useRef();
  const remarkRef = useRef();
  const inspectionToolRef = useRef();
  const UCL_xBarRef = useRef();
  const CL_xBarRef = useRef();
  const LCL_xBarRef = useRef();
  const UCL_rChartRef = useRef();
  const CL_rChartRef = useRef();
  const LCL_rChartRef = useRef();

  const [formula, setFormula] = useState();

  const snackBarState = useSnackbarStore();

  const checkError = () => {
    if (specMinRef.current) {
      setErrorMinMax(
        parseFloat(specMinRef.current.value) >
          parseFloat(specMaxRef.current.value) ||
          parseFloat(specMinRef.current.value) ===
            parseFloat(specMaxRef.current.value)
      );
    }
  };
  const fetchTemplates = async () => {
    try {
      const response = await APIServices.getAllTemplate();
      console.log(response.data.data);

      setTemplates(response.data.data);
    } catch (error) {
      console.error("Error fetching templates:", error);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseAlert = () => {
    setAlert((data) => ({ ...data, open: false }));
  };

  const findOnePart = async () => {
    console.log("use api");
    const findPart = await APIServices.findOnePartForFromAddQuestion(partId);
    const partData = findPart.data.data;
    setPart({
      id: partData.id,
      ...partData.attributes,
    });
  };

  const handleChangeQuestion = (e) => {
    setQuestion(e.target.value);
  };
  const handleChangeSpecMin = (e) => {
    setSpecMin(e.target.value);
  };
  const handleChangeSpecMax = (e) => {
    setSpecMax(e.target.value);
  };
  const handleChangeInspectionTool = (e) => {
    setInspectionTool(e.target.value);
  };
  const handleChangeRemark = (e) => {
    setRemark(e.target.value);
  };

  const hanldeChangeUclXbar = (e) => {
    setUCL_Xbar(e.target.value);
  };

  const handleChnageLclXbar = (e) => {
    setLCL_Xbar(e.target.value);
  };
  const hanldeChangeClXbar = (e) => {
    setCL_Xbar(e.target.value);
  };

  const hanldeChangeUclRchart = (e) => {
    setUCL_Rchart(e.target.value);
  };

  const hanldeChangeClRchart = (e) => {
    setCL_Rchart(e.target.value);
  };

  const handleChangeLclRchart = (e) => {
    setLCL_Rchart(e.target.value);
  };

  const editTemplate = async (
    templateId,
    question,
    specMin,
    specMax,
    sc_status,
    inspectionTool,
    remark,
    UCL_xBar,
    CL_xBar,
    LCL_xBar,
    UCL_rChart,
    CL_rChart,
    LCL_rChart
  ) => {
    const signature =
      user.signature !== null
        ? user.signature[user.signature.length - 1].url
        : "";
    if (question === "") {
      setAlert({
        open: true,
        type: "error",
        massage: "ไม่มีข้อมูลคำถาม",
      });
      return;
    }
    if (question === "") {
      setAlert({
        open: true,
        type: "error",
        massage: "ยังไม่ได้ทำการเพิ่มคำถาม",
      });
    } else {
      console.log(templateData.id, question);
      setLoading(true);
      const response = await APIServices.editTemplateById(
        templateId,
        question,
        specMin,
        specMax,
        sc_status,
        inspectionTool,
        remark,
        UCL_xBar,
        CL_xBar,
        LCL_xBar,
        UCL_rChart,
        CL_rChart,
        LCL_rChart
      );

      setTimeout(() => {
        setSuccess(true);
        setLoading(false);
        setOpen(false);
      }, 1500);
      snackBarState.onOpen({
        msg: "เพิ่มข้อมูลสำเร็จ",
        type: "success",
      });
    }
    onUpdate();
  };

  useEffect(() => {
    findOnePart();
  }, []);
  useEffect(() => {
    fetchTemplates();
  }, []);
  useEffect(() => {
    console.log("CHECK TEMPLATE", templateData);
  }, [templateData]);

  useEffect(() => {
    if (templateData && templateData.attributes.sc_status !== undefined) {
      setIsSC(templateData.attributes.sc_status);
    }
    if (templateData && templateData.attributes.question !== undefined) {
      setQuestion(templateData.attributes.question);
    }
    if (templateData && templateData.attributes.spec_min !== undefined) {
      setSpecMin(templateData.attributes.spec_min);
    }
    if (templateData && templateData.attributes.spec_max !== undefined) {
      setSpecMax(templateData.attributes.spec_max);
    }
    if (templateData && templateData.attributes.inspectionTool !== undefined) {
      setInspectionTool(templateData.attributes.inspectionTool);
    }
    if (templateData && templateData.attributes.remark !== undefined) {
      setRemark(templateData.attributes.remark);
    }
    if (templateData && templateData.attributes.UCL_Xbar !== undefined) {
      setUCL_Xbar(templateData.attributes.UCL_Xbar);
    }
    if (templateData && templateData.attributes.LCL_Xbar !== undefined) {
      setLCL_Xbar(templateData.attributes.LCL_Xbar);
    }
    if (templateData && templateData.attributes.CL_Xbar !== undefined) {
      setCL_Xbar(templateData.attributes.CL_Xbar);
    }
    if (templateData && templateData.attributes.UCL_Xbar !== undefined) {
      setLCL_Rchart(templateData.attributes.UCL_Xbar);
    }
    if (templateData && templateData.attributes.LCL_Xbar !== undefined) {
      setUCL_Rchart(templateData.attributes.LCL_Xbar);
    }
    if (templateData && templateData.attributes.CL_Xbar !== undefined) {
      setCL_Rchart(templateData.attributes.CL_Xbar);
    }
  }, [templateData]);

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      maxWidth={"sm"}
      fullWidth
      sx={{
        position: "absolute",
        top: "10px",
        left: "200px",
        margin: 0,
      }}
    >
      <SimpleBackdrop open={loading} setOpen={setLoading} />

      <div>
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={snackBarState.open}
          autoHideDuration={6000}
          onClose={snackBarState.onClose}
        >
          <Alert severity={snackBarState.type}>{snackBarState.message}</Alert>
        </Snackbar>
      </div>
      <DialogTitle>แบบฟอร์มแก้ไข ชุดคำถาม</DialogTitle>

      <DialogContent dividers>
        <Box
          component="form"
          sx={{
            "& .MuiTextField-root": {
              // mr: 2,
              // width: 500,
              width: "100%",
              mt: 2,
            },
          }}
          noValidate
          autoComplete="off"
        >
          <div className="flex flex-col ">
            <div className={`flex flex-row justify-center items-start mb-2`}>
              <div className={`flex flex-col items-baseline mb-2`}></div>
            </div>
            <div></div>
            <div className="flex flex-row">
              <div className="basis-1/4 flex flex-row justify-center items-center m-1">
                <span>SC</span>
                <Switch
                  inputRef={switchRef}
                  checked={isSC}
                  {...label}
                  onChange={(e) => setIsSC(e.target.checked)}
                />
              </div>
              <div className="m-1 basis-3/4 flex items-center ">
                <TextField
                  inputRef={questionRef}
                  label="คำถาม"
                  value={question}
                  onChange={handleChangeQuestion}
                />
              </div>
            </div>

            <div className="flex gap-4">
              <div className="basis-1/2">
                <TextField
                  onWheel={(event) => event.target.blur()}
                  fullWidth
                  type={"number"}
                  onBlur={() => checkError()}
                  inputRef={specMinRef}
                  onChange={handleChangeSpecMin}
                  // value={templateData ? templateData.attributes.spec_min : ""}
                  value={specMin}
                  label="min"
                  error={errorMinMax}
                  helperText={errorMinMax && "มีค่ามากกว่าหรือเท่ากับ Spec Max"}
                />
              </div>
              <div className="basis-1/2">
                <TextField
                  onWheel={(event) => event.target.blur()}
                  type={"number"}
                  onBlur={() => checkError()}
                  inputRef={specMaxRef}
                  onChange={handleChangeSpecMax}
                  // value={templateData ? templateData.attributes.spec_max : ""}
                  value={specMax}
                  label="max"
                  error={errorMinMax}
                  helperText={
                    errorMinMax && "มีค่าน้อยกว่าหรือเท่ากับ Spec Min "
                  }
                />
              </div>
            </div>
            <div className="flex w-full items-center ">
              <TextField
                inputRef={inspectionToolRef}
                onChange={handleChangeInspectionTool}
                // value={
                //   templateData ? templateData.attributes.inspectionTool : ""
                // }
                label="Inspection Tool"
                value={inspectionTool}
              />
            </div>
            <div className="flex w-full items-center ">
              <TextField
                inputRef={remarkRef}
                onChange={handleChangeRemark}
                // value={templateData ? templateData.attributes.remark : ""}
                value={remark}
                label="หมายเหตุ"
              />
            </div>
            {/* {isSC && (
              <> */}
            <div className="flex flex-col mt-2">
              <span className="mt-2  font-semibold">X-bar</span>
              <div className="flex flex-row">
                <div className="m-1">
                  <TextField
                    disabled={!isSC}
                    inputRef={UCL_xBarRef}
                    onChange={hanldeChangeUclXbar}
                    // value={isSC && templateData.attributes.UCL_Xbar}
                    value={isSC && UCL_Xbar}
                    label="UCL"
                    type="number"
                    onWheel={(event) => event.target.blur()}
                  />
                </div>
                <div className="m-1">
                  <TextField
                    disabled={!isSC}
                    inputRef={CL_xBarRef}
                    value={isSC && CL_Xbar}
                    onChange={hanldeChangeClXbar}
                    label="CL"
                    type="number"
                    onWheel={(event) => event.target.blur()}
                  />
                </div>
                <div className="m-1">
                  <TextField
                    disabled={!isSC}
                    inputRef={LCL_xBarRef}
                    onChange={handleChnageLclXbar}
                    // value={templateData && templateData.attributes.LCL_Xbar}
                    value={isSC && LCL_Xbar}
                    label="LCL"
                    type="number"
                    onWheel={(event) => event.target.blur()}
                  />
                </div>
              </div>
            </div>

            <div className="flex flex-col mt-2">
              <span className="mt-2 font-semibold">R-chart</span>
              <div className="flex flex-row">
                <div className="m-1">
                  <TextField
                    disabled={!isSC}
                    inputRef={UCL_rChartRef}
                    // value={templateData && templateData.attributes.UCL_Rchart}
                    value={isSC && UCL_Rchart}
                    onChange={hanldeChangeUclRchart}
                    label="UCL"
                    type="number"
                    onWheel={(event) => event.target.blur()}
                  />
                </div>
                <div className="m-1">
                  <TextField
                    disabled={!isSC}
                    inputRef={CL_rChartRef}
                    value={isSC && CL_Rchart}
                    onChange={hanldeChangeClRchart}
                    label="CL"
                    type="number"
                    onWheel={(event) => event.target.blur()}
                  />
                </div>
                <div className="m-1">
                  <TextField
                    inputRef={LCL_rChartRef}
                    onChange={handleChangeLclRchart}
                    // value={templateData && templateData.attributes.LCL_Rchart}
                    value={isSC && LCL_Rchart}
                    label="LCL"
                    type="number"
                    disabled={!isSC}
                    onWheel={(event) => event.target.blur()}
                  />
                </div>
              </div>
            </div>
          </div>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          disabled={errorMinMax}
          autoFocus
          variant="contained"
          onClick={() => {
            editTemplate(
              templateData.id,
              question,
              specMin,
              specMax,
              isSC,
              inspectionTool,
              remark,
              UCL_Xbar,
              CL_Xbar,
              LCL_Xbar,
              UCL_Rchart,
              CL_Rchart,
              LCL_Rchart
            );
          }}
        >
          แก้ไข
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
}

export default TemplateEdit;
